export class TehsilModel{
    id: any;
    districtId: any;
    tehsilName: any;
    isActive: any;
}